import { Alert } from '@nutanix-ui/prism-reactjs';
import { AlertTypes } from '@nutanix-ui/prism-reactjs/lib/components/v2/Alert/Alert';
import React from 'react';
import './Alert.less';
import PropTypes from 'prop-types';

const AlertMessage = ({ message, type, showCloseIcon = false }) => {
    return (
        <Alert
            data-testid="ant-alert-message"
            className="login-alert"
            showCloseIcon={showCloseIcon}
            type={type}
            message={message}
        />
    );
};
AlertMessage.propTypes = {
    message: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(AlertTypes)).isRequired,
    showCloseIcon: PropTypes.bool,
};

export default AlertMessage;
